import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from '../routes/Routes';
import { ListagemProvider } from '../presentations';

function App() {
  return (
    <ListagemProvider>
      <BrowserRouter children={<Routes/>}
        basename={'/'} />
    </ListagemProvider>
  );
}

export default App;